import React, { useEffect, useState } from "react";
import { ImageBackground, Text, View } from "react-native";
import { navigateAction, popAction, replaceAction } from "../../helpers/navigationHelpers";
import getPlatformType, { getImage } from "../../helpers/getPlatform";
import BackGroundGenerator from "../LandingPages/common/BackGroundGenerator";
import ODSButton from "../../../openbrix-design-system/ui/atoms/ODSButton";
import WebMaintenanceView from "./WebMaintenanceView";
import MobileMaintenanceView from "./MobileMaintenanceView";
import { TenantService } from "../openFlow/openFlowRedux/tenant.service";
import { useIsFocused } from "@react-navigation/native";


const ViewIssue = (props) => {
  const [expandedId, setExpandedId] = useState(null);
  const [issueList, setIssueList] = useState([]);
  const [roomTypes, setRoomTypes] = useState([]);
  const [categoryTypes, setCategoryTypes] = useState([]);
  const layoutType = getPlatformType();
  const isWeb = layoutType === "web";

  const handleItemPress = (id) => {
    setExpandedId(expandedId === id ? null : id);
  };
  let focus =useIsFocused()
  useEffect(() => {
    fetchData();
  }, [props?.route?.params?.id,focus]);
  console.log("issueList", issueList)
  const fetchData = async () => {
    try {
      const [issueRes, roomsRes, categoriesRes] = await Promise.all([
        TenantService.getIssueList(),
        TenantService.getRoomTypes(),
        TenantService.getCatogoriesTypes(),
      ]);

      setRoomTypes(roomsRes?.data?.data || []);
      setCategoryTypes(categoriesRes?.data?.data || []);

      if (issueRes?.data?.data?.length) {
        setIssueList(issueRes.data.data)
      }
      console.log("issueRes", issueRes)
    } catch (err) {
      console.log("Error fetching maintenance lists:", err);
    }
  };
  return (
    <BackGroundGenerator isTLYF props={props}>
        
        <ImageBackground
            source={getImage('openflow.png')}
            style={{ width: '100%', height: 300 }}
            resizeMode={'cover'}
          >
      <ODSButton
        rIcon="TB-Arrow-Left"
        restStyle={[styles.backButton,{marginTop:20}]}
        type="secondary"
        disabled={false}
        onPress={() => replaceAction(props?.navigation, "My Tenancy",{id: props?.route?.params?.id, isMoveOut: false})}
      >
        My Tenancy
      </ODSButton>
          </ImageBackground>


      <View style={[
        styles.container,
        isWeb ? styles.webWidth : styles.mobileWidth
      ]}>
        <View style={styles.header}>
          <Text style={styles.pageTitle}>Maintenance Issues</Text>
          <Text style={styles.pageSubtitle}>
            View and manage your maintenance requests
          </Text>
          <ODSButton
            rIcon="Frame"
            restStyle={[styles.backButton, { alignSelf: "flex-end" , marginTop:layoutType=="phone"?20:0}]}
            type="secondary"
            disabled={false}
            onPress={() =>
              navigateAction(props?.navigation, "Maintenance", { id: props?.route?.params?.id })
            }
          >
            Add issue
          </ODSButton>
        </View>

        {isWeb ? (
          <WebMaintenanceView
            data={issueList}
            expandedId={expandedId}
            roomTypes={roomTypes}
            categoryTypes={categoryTypes}
            onItemPress={handleItemPress}
            flowId={props?.route?.params?.id}
            navigation={props.navigation}
          />
        ) : (
          <MobileMaintenanceView
            data={issueList}
            expandedId={expandedId}
            onItemPress={handleItemPress}
            roomTypes={roomTypes}
            categoryTypes={categoryTypes}
            flowId={props?.route?.params?.id}
            navigation={props.navigation}
          />
        )}
      </View>
    </BackGroundGenerator>
  );
};

const styles = {
  container: {
    alignSelf: 'center',
  },
  webWidth: {
    width: 1200,
    maxWidth: '95%',
    top:-230
  },
  mobileWidth: {
    width: '95%',
  },
  backButton: {

    marginLeft: 20,
    width: 200,
  },
  header: {
    marginBottom: 20,
  },
  pageTitle: {
    fontSize: 28,
    fontWeight: 'bold',
    color: '#1F2937',
    textAlign: 'center',
    marginBottom: 8,
  },
  pageSubtitle: {
    fontSize: 16,
    color: '#6B7280',
    textAlign: 'center',
  },
};

export default ViewIssue;
